import React from "react";
import WithAuth from "../../hoc/WithAuth";
import InputSalesTable from "../../components/tables/input/InputSalesTable";

const InputSalesPage = () => {
  return <InputSalesTable />;
};

export default WithAuth(InputSalesPage);
